import { LoaderFnConfig } from '@frontend/loaders';
import { ClientConfigProductName } from '@frontend/vanilla/core';

export const PanicButtonLoader: LoaderFnConfig = {
    id: 'panic-button',
    loaderFn: () => import('./panic-button.feature'),
    product: ClientConfigProductName.SPORTS,
};
